var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "saas-page engagement-page linear-command-page" },
    [
      _c("div", { staticClass: "saas-hero card-saas engagement-page__hero" }, [
        _c("div", { staticClass: "saas-hero__main" }, [
          _c(
            "p",
            { staticClass: "saas-hero__crumb" },
            [
              _c("router-link", { attrs: { to: "/home" } }, [
                _vm._v(_vm._s(_vm.trans("general.home"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.trans("query.query")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c("h1", { staticClass: "saas-hero__title" }, [
            _vm._v(_vm._s(_vm.trans("query.query"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "engagement-page__actions" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.showFilterPanel = !_vm.showFilterPanel
                },
              },
            },
            [
              _c("admin-icon", { attrs: { name: "sliders" } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.trans("general.filter")))]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "engagement-command-grid" }, [
        _c("section", { staticClass: "engagement-command-card" }, [
          _c("span", [_vm._v(_vm._s(_vm.trans("query.query")))]),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.queries.total || 0))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.queries.total
                  ? _vm.trans("general.total_result_found", {
                      count: _vm.queries.total,
                    })
                  : _vm.trans("general.no_result_found")
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass:
              "engagement-command-card engagement-command-card--muted",
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.trans("query.status")))]),
            _vm._v(" "),
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.filterQueryForm.status || _vm.trans("general.select_one")
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.trans("query.keyword")) +
                  ": " +
                  _vm._s(_vm.filterQueryForm.keyword || "-")
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass:
              "engagement-command-card engagement-command-card--muted",
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.trans("general.sort_by")))]),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.filterQueryForm.sort_by))]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.trans("general.order")) +
                  ": " +
                  _vm._s(_vm.filterQueryForm.order)
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showFilterPanel
          ? _c("div", { staticClass: "card-saas engagement-filter-card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h4", { staticClass: "card-saas__title" }, [
                  _vm._v(_vm._s(_vm.trans("general.filter"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("query.keyword"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterQueryForm.keyword,
                            expression: "filterQueryForm.keyword",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "keyword" },
                        domProps: { value: _vm.filterQueryForm.keyword },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filterQueryForm,
                              "keyword",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("query.first_name"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterQueryForm.first_name,
                            expression: "filterQueryForm.first_name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "first_name" },
                        domProps: { value: _vm.filterQueryForm.first_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filterQueryForm,
                              "first_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("query.last_name"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterQueryForm.last_name,
                            expression: "filterQueryForm.last_name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "last_name" },
                        domProps: { value: _vm.filterQueryForm.last_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filterQueryForm,
                              "last_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("query.email"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterQueryForm.email,
                            expression: "filterQueryForm.email",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "email" },
                        domProps: { value: _vm.filterQueryForm.email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filterQueryForm,
                              "email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("query.phone"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterQueryForm.phone,
                            expression: "filterQueryForm.phone",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "phone" },
                        domProps: { value: _vm.filterQueryForm.phone },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filterQueryForm,
                              "phone",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("query.status"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterQueryForm.status,
                              expression: "filterQueryForm.status",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "status" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterQueryForm,
                                "status",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.trans("general.select_one"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "replied" } }, [
                            _vm._v(_vm._s(_vm.trans("query.replied"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "unanswered" } }, [
                            _vm._v(_vm._s(_vm.trans("query.unanswered"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "under_process" } }, [
                            _vm._v(_vm._s(_vm.trans("query.under_process"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "awaiting_response" } },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("query.awaiting_response"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "resolved" } }, [
                            _vm._v(_vm._s(_vm.trans("query.resolved"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("date-range-picker", {
                          attrs: {
                            "start-date": _vm.filterQueryForm.start_date,
                            "end-date": _vm.filterQueryForm.end_date,
                            label: _vm.trans("general.date_between"),
                          },
                          on: {
                            "update:startDate": function ($event) {
                              return _vm.$set(
                                _vm.filterQueryForm,
                                "start_date",
                                $event
                              )
                            },
                            "update:start-date": function ($event) {
                              return _vm.$set(
                                _vm.filterQueryForm,
                                "start_date",
                                $event
                              )
                            },
                            "update:endDate": function ($event) {
                              return _vm.$set(
                                _vm.filterQueryForm,
                                "end_date",
                                $event
                              )
                            },
                            "update:end-date": function ($event) {
                              return _vm.$set(
                                _vm.filterQueryForm,
                                "end_date",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("general.sort_by"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterQueryForm.sort_by,
                              expression: "filterQueryForm.sort_by",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "order" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterQueryForm,
                                "sort_by",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "first_name" } }, [
                            _vm._v(_vm._s(_vm.trans("query.first_name"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "last_name" } }, [
                            _vm._v(_vm._s(_vm.trans("query.last_name"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "email" } }, [
                            _vm._v(_vm._s(_vm.trans("query.email"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "phone" } }, [
                            _vm._v(_vm._s(_vm.trans("query.phone"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "subject" } }, [
                            _vm._v(_vm._s(_vm.trans("query.subject"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "created_at" } }, [
                            _vm._v(_vm._s(_vm.trans("query.created_at"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "status" } }, [
                            _vm._v(_vm._s(_vm.trans("query.status"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(_vm._s(_vm.trans("general.order"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterQueryForm.order,
                              expression: "filterQueryForm.order",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "order" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filterQueryForm,
                                "order",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "asc" } }, [
                            _vm._v(_vm._s(_vm.trans("general.ascending"))),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "desc" } }, [
                            _vm._v(_vm._s(_vm.trans("general.descending"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.hasPermission("list-query") && _vm.queries.total
        ? _c("div", { staticClass: "admin-list-table-card mt-3" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table admin-data-table mb-0" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "first_name",
                            "sort-by": _vm.filterQueryForm.sort_by,
                            order: _vm.filterQueryForm.order,
                          },
                          on: { sort: _vm.sortList },
                        },
                        [_vm._v(_vm._s(_vm.trans("query.first_name")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "last_name",
                            "sort-by": _vm.filterQueryForm.sort_by,
                            order: _vm.filterQueryForm.order,
                          },
                          on: { sort: _vm.sortList },
                        },
                        [_vm._v(_vm._s(_vm.trans("query.last_name")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "status",
                            "sort-by": _vm.filterQueryForm.sort_by,
                            order: _vm.filterQueryForm.order,
                          },
                          on: { sort: _vm.sortList },
                        },
                        [_vm._v(_vm._s(_vm.trans("query.status")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "email",
                            "sort-by": _vm.filterQueryForm.sort_by,
                            order: _vm.filterQueryForm.order,
                          },
                          on: { sort: _vm.sortList },
                        },
                        [_vm._v(_vm._s(_vm.trans("query.email")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "phone",
                            "sort-by": _vm.filterQueryForm.sort_by,
                            order: _vm.filterQueryForm.order,
                          },
                          on: { sort: _vm.sortList },
                        },
                        [_vm._v(_vm._s(_vm.trans("query.phone")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "subject",
                            "sort-by": _vm.filterQueryForm.sort_by,
                            order: _vm.filterQueryForm.order,
                          },
                          on: { sort: _vm.sortList },
                        },
                        [_vm._v(_vm._s(_vm.trans("query.subject")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "sortable-th",
                        {
                          attrs: {
                            field: "created_at",
                            "sort-by": _vm.filterQueryForm.sort_by,
                            order: _vm.filterQueryForm.order,
                          },
                          on: { sort: _vm.sortList },
                        },
                        [_vm._v(_vm._s(_vm.trans("query.created_at")))]
                      ),
                      _vm._v(" "),
                      _c("th", { staticClass: "admin-table-actions-cell" }, [
                        _vm._v(_vm._s(_vm.trans("general.actions"))),
                      ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.queries.data, function (query) {
                    return _c("tr", { key: query.id }, [
                      _c("td", [
                        _c("span", {
                          staticClass: "engagement-table__primary",
                          domProps: { textContent: _vm._s(query.first_name) },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "engagement-table__meta" }, [
                          _vm._v("#" + _vm._s(query.id)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", {
                          staticClass: "engagement-table__primary",
                          domProps: { textContent: _vm._s(query.last_name) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", {
                        domProps: { innerHTML: _vm._s(_vm.getStatus(query)) },
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", {
                          staticClass: "engagement-table__muted",
                          domProps: { textContent: _vm._s(query.email) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", {
                          staticClass: "engagement-table__muted",
                          domProps: { textContent: _vm._s(query.phone) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", {
                          staticClass: "engagement-table__subject",
                          domProps: { textContent: _vm._s(query.subject) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "engagement-table__muted" }, [
                          _vm._v(_vm._s(_vm._f("moment")(query.created_at))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "admin-table-actions-cell" },
                        [
                          _c(
                            "table-row-action-dropdown",
                            [
                              _c(
                                "b-dropdown-item-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.openQueryDetail(query)
                                    },
                                  },
                                },
                                [
                                  _c("admin-icon", { attrs: { name: "eye" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.trans("query.view")) +
                                      "\n                                "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.hasPermission("delete-query")
                                ? _c(
                                    "b-dropdown-item-button",
                                    {
                                      directives: [
                                        {
                                          name: "confirm",
                                          rawName: "v-confirm",
                                          value: {
                                            ok: _vm.confirmDelete(query),
                                          },
                                          expression:
                                            "{ok: confirmDelete(query)}",
                                        },
                                      ],
                                      staticClass: "admin-row-actions__danger",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "trash" },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.trans("general.delete")) +
                                          "\n                                "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "admin-table-pagination-wrap" },
              [
                _c("pagination-record", {
                  attrs: {
                    "page-length": _vm.filterQueryForm.page_length,
                    records: _vm.queries,
                  },
                  on: {
                    "update:pageLength": function ($event) {
                      return _vm.$set(
                        _vm.filterQueryForm,
                        "page_length",
                        $event
                      )
                    },
                    "update:page-length": function ($event) {
                      return _vm.$set(
                        _vm.filterQueryForm,
                        "page_length",
                        $event
                      )
                    },
                    updateRecords: _vm.getQueries,
                  },
                  nativeOn: {
                    change: function ($event) {
                      return _vm.getQueries.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "modal fade query-detail engagement-query-modal admin-modal-pro sip-view-modal",
          attrs: {
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "queryDetail",
            "aria-hidden": "true",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c(
              "div",
              { staticClass: "modal-content admin-modal-pro__content" },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "queryDetail" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.query.subject || _vm.trans("query.query"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-hidden": "true",
                      },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _vm.query
                  ? _c("div", { staticClass: "modal-body" }, [
                      _vm.query.created_at
                        ? _c(
                            "p",
                            { staticClass: "sip-view-status__meta mb-3" },
                            [
                              _vm._v(
                                _vm._s(_vm._f("moment")(_vm.query.created_at))
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 col-sm-6" }, [
                          _c("dl", { staticClass: "sip-view-dl" }, [
                            _c("div", { staticClass: "sip-view-dl__row" }, [
                              _c("dt", [
                                _vm._v(_vm._s(_vm.trans("query.name"))),
                              ]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  _vm._s(
                                    _vm.query.first_name +
                                      " " +
                                      _vm.query.last_name
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sip-view-dl__row" }, [
                              _c("dt", [
                                _vm._v(_vm._s(_vm.trans("query.email"))),
                              ]),
                              _vm._v(" "),
                              _c("dd", [_vm._v(_vm._s(_vm.query.email))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sip-view-dl__row" }, [
                              _c("dt", [
                                _vm._v(_vm._s(_vm.trans("query.phone"))),
                              ]),
                              _vm._v(" "),
                              _c("dd", [_vm._v(_vm._s(_vm.query.phone))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sip-view-dl__row" }, [
                              _c("dt", [_vm._v(_vm._s(_vm.trans("query.ip")))]),
                              _vm._v(" "),
                              _c("dd", [_vm._v(_vm._s(_vm.query.ip))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sip-view-dl__row" }, [
                              _c("dt", [
                                _vm._v(_vm._s(_vm.trans("query.user_agent"))),
                              ]),
                              _vm._v(" "),
                              _c("dd", [_vm._v(_vm._s(_vm.query.user_agent))]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.hasPermission("edit-query")
                          ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                              _c(
                                "h4",
                                { staticClass: "sip-view-section-title" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.trans("query.update_status"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("div", { staticClass: "admin-radio" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.status,
                                        expression: "status",
                                      },
                                    ],
                                    attrs: {
                                      type: "radio",
                                      value: "unanswered",
                                      id: "status_unanswered",
                                    },
                                    domProps: {
                                      checked:
                                        _vm.query.status === "unanswered",
                                      checked: _vm._q(_vm.status, "unanswered"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.status = "unanswered"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { attrs: { for: "status_unanswered" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.trans("query.unanswered")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "admin-radio" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.status,
                                        expression: "status",
                                      },
                                    ],
                                    attrs: {
                                      type: "radio",
                                      value: "replied",
                                      id: "status_replied",
                                    },
                                    domProps: {
                                      checked: _vm.query.status === "replied",
                                      checked: _vm._q(_vm.status, "replied"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.status = "replied"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { attrs: { for: "status_replied" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.trans("query.replied")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "admin-radio" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.status,
                                        expression: "status",
                                      },
                                    ],
                                    attrs: {
                                      type: "radio",
                                      value: "under_process",
                                      id: "status_under_process",
                                    },
                                    domProps: {
                                      checked:
                                        _vm.query.status === "under_process",
                                      checked: _vm._q(
                                        _vm.status,
                                        "under_process"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.status = "under_process"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { attrs: { for: "status_under_process" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.trans("query.under_process")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "admin-radio" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.status,
                                        expression: "status",
                                      },
                                    ],
                                    attrs: {
                                      type: "radio",
                                      value: "awaiting_response",
                                      id: "status_awaiting_response",
                                    },
                                    domProps: {
                                      checked:
                                        _vm.query.status ===
                                        "awaiting_response",
                                      checked: _vm._q(
                                        _vm.status,
                                        "awaiting_response"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.status = "awaiting_response"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "status_awaiting_response",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.trans("query.awaiting_response")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "admin-radio" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.status,
                                        expression: "status",
                                      },
                                    ],
                                    attrs: {
                                      type: "radio",
                                      value: "resolved",
                                      id: "status_resolved",
                                    },
                                    domProps: {
                                      checked: _vm.query.status === "resolved",
                                      checked: _vm._q(_vm.status, "resolved"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.status = "resolved"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { attrs: { for: "status_resolved" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.trans("query.resolved")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                                    attrs: { type: "button" },
                                    on: { click: _vm.updateStatus },
                                  },
                                  [_vm._v(_vm._s(_vm.trans("general.save")))]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "sip-view-rich sip-view-thread__body",
                        domProps: { innerHTML: _vm._s(_vm.query.body) },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(_vm._s(_vm.trans("general.close")))]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.queries.total
        ? _c(
            "div",
            {
              staticClass: "admin-list-table-card admin-empty-state mt-3",
              attrs: { role: "status" },
            },
            [
              _c("div", { staticClass: "admin-empty-state__inner" }, [
                _c(
                  "div",
                  {
                    staticClass: "admin-empty-state__icon-wrap",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_c("admin-icon", { attrs: { name: "chat" } })],
                  1
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "admin-empty-state__title" }, [
                  _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }